// Счётчики панели микрофона: сколько слов уже сказано и с каким темпом.
//
// Считаем вместе с живой гипотезой, а не только по финалам: на монологе без пауз
// первый финал приходит лишь на «Остановить», и панель до самого конца показывала
// ноль, хотя на экране росли строки. Цена — число слегка подрагивает, когда движок
// переразбирает хвост фразы; застывший ноль вводит в заблуждение сильнее.

// Меньше трёх секунд — темп посчитан по одному-двум словам и скачет; показываем прочерк.
const MIN_SEC_FOR_PACE = 3;

/** Слова в готовом тексте и текущей гипотезе. */
export function countWords(finalText, partialText) {
  const text = `${String(finalText || '')} ${String(partialText || '')}`.trim();
  return text ? text.split(/\s+/).length : 0;
}

/** Темп речи словами в минуту или «—», если считать ещё не по чему. */
export function paceLabel(words, elapsedSec) {
  if (!words || elapsedSec < MIN_SEC_FOR_PACE) return '—';
  return `${Math.round((words / elapsedSec) * 60)} сл/мин`;
}
